import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss',
  "../../../../../../assets/sass/libs/datatables.scss",],
  encapsulation: ViewEncapsulation.None,
})
export class ListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 100,
    totalPages: 0
  };
  // row data
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue = ''
  isFilter: boolean = false
  // column header
  public columns = [
    { name: "Name", prop: "displayname" },
    { name: "Description", prop: "description" },
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
  ];

  // private
  private tempData = [];
  imageUrl = environment.apiUrls.imageUrl;

  checklist_id: any;
  searchVal: any;
  @ViewChild('name') inputName;
  user_role: any
  list_type=[]
  selected_type_list=null
  row_json_data:any
  row_json_dataa=[]
  row_json_id:any
  row_id:any
  checklist_model = {
    sprint:[ {
      data: {}
    }],
  }
  activeTab =''

  guideline_data:any
  key_Values: any[] = [];
  sprint_dataId:any;
  sprint_id:any;
  check_id:any
  constructor(public apiService: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public toastr: ToastrService,private activerouter: ActivatedRoute,
    private route : Router) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Checklist') 
    this.guideline_data = key_data[0]?._id
    this.getCheckListType()   
     
  }

  ngOnInit(): void {
    this.activerouter.queryParams
    .subscribe((params: any) => {
      this.activeTab = params?.status;
    })
    if(this.activeTab){
      this.activeCheckListTab(this.activeTab)
    }
    else{
      this.activeCheckListTab('list')
    }
    
  }
  activeCheckListTab(tab) {
    const activetab = tab;
    this.activeTab = tab
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activerouter, queryParams: { status: activetab } }
      );
    }
  }
  setAndGetChecklistbyType() {
    this.activerouter.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        this.getCheckList()
      })
  }
  getCheckList() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      let type = this.list_type.find((item) => item.name == this.activeTab)
      this.apiService.getAllChecklist(this.page.pageNumber + 1, this.limitRef,type._id).subscribe((res: any) => {
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.fillterCount
    })
  }
  getCategoryFilter(data: any) {
    let search = data
    if (search) {
      this.apiService.getCategorySearch(search).subscribe((res: any) => {
        this.rows = res.data
      })
    }
  }
  resetFilter() {
    this.inputName.nativeElement.value = ''
    this.setAndGetChecklistbyType()
  }
  pageChangeData(page: any) {
    this.apiService.getAllCategory(page.offset + 1, page.pageSize).subscribe((res: any) => {
      this.rows = res.data.items
      this.page.totalPages = res.data.totalCount

    })
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * filterUpdate
   *
   * @param event
   */
  filterUpdate(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.tempData.filter(function (d) {
      return d.Username.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    this.filterRows = temp
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  /**
   * updateLimit
   *
   * @param limit
   */
  updateLimit(limit) {
    this.limitRef = limit.target.value;
    this.apiService.getAllCategory(1, this.limitRef).subscribe((res: any) => {
      this.rows = res.data.users
    })
  }
  deleteChecklist(password) {
    if (this.checklist_id) {
      this.apiService.deleteChecklist(this.checklist_id,password).subscribe((res: any) => {
        if (res.statusCode === 200) {
          swal.fire({
            icon: "success",
            title: 'Deleted!',
            text: 'Your file has been deleted.',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
          this.setAndGetChecklistbyType()
        }
        else{
          swal.fire({
            icon: "error",
            title: 'Error!',
            text: `${res.error}`,
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        }
      })
    }
    else {
      this.toastr.error('something went wrong !!')
    }
  }
  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.checklist_id = id
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then( (result)=> {
      if (result.value) {  
        this.deleteChecklist(result.value)      
        
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  // ==========================================

  getCheckListType(){
    this.apiService.getTagByTagCatgoryId('65268dbf37d5731c9401d3fe').subscribe((res:any)=>{
      this.list_type=res.data
      this.setAndGetChecklistbyType()
    })
  }
  getTypeListId(event){
    this.selected_type_list
  }
  openPopup(content,id,data){
    console.log(data)
    this.row_id = id
    this.row_json_id = data[0]._id
    // this.row_json_data = JSON.parse(data[0].data)
    this.row_json_data =data[0].data
    this.row_json_dataa =  Object.keys(this.row_json_data);
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  updateValue(){
    // let new_json= JSON.stringify(this.row_json_data)
    // console.log(this.row_json_data,'jjj')
    this.convertToJson(this.row_json_data)
    let body ={
      data :   this.row_json_data
    }
   
    this.apiService.updateSprintChecklist(this.row_json_id,this.row_id,body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.setAndGetChecklistbyType()
        
      }
      else this.toastr.error(res?.error)
    })
  }
  convertToJson(data) {
    // const obj = {};
    // data.split(",").forEach((val) => {
    //   const [key, value] = val.split(":");
    //   obj[key] = value.trim().toLowerCase() === "true";
    //   obj[key] = value.trim().toLowerCase() === "false";

    // });
  
    // // Convert the object to a JSON string if needed
    // // const jsonString = JSON.stringify(obj);
    // // this.checklist_model.sprint[0].data = obj
    // // console.log('==>>', jsonString); // JSON string
    // console.log('obj',obj); // Object with boolean values
    // const datat = JSON.stringify(obj);

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
          data[key] = data[key] === "true";
      }
    }

  this.row_json_data = data
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  openDataModel(content,id,sprint_id,sprint_data_id){
    this.check_id = id
    this.sprint_id = sprint_id
    this.sprint_dataId = sprint_data_id
    this.getChecklistById(id)
    const modalOptions: NgbModalOptions = {
       // 'sm', 'lg', or 'xl',
      backdrop: "static",
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then(
      (result) => {
        // console.log(`Modal closed with result: ${result}`);
      },
      (reason) => {
        // console.log(`Modal dismissed with reason: ${reason}`);
      }
    );

  }
  getChecklistById(id){


    this.apiService.getChecklistById(id).subscribe((res:any)=>{
      
      let data = res?.data[0]?.sprint[0]?.sprint_data[0].data
      this.key_Values = Object.entries(data)
    })
  }
  addItem() {
    this.key_Values.push({ key: '', value: '' });
  }
  removeItem(index: number) {
    this.key_Values.splice(index, 1);
  }

  updateCheck(){
    this.key_Values.forEach(item => {
      item[1]=JSON.parse(item[1])
    });
    const new_json = Object.fromEntries(this.key_Values as any[]);
    let body={
      data: new_json
    }
    this.apiService.updateChecklistSprint(this.sprint_id,this.sprint_dataId,body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success('update successfull!')
        this.getChecklistById(this.check_id)
      }
    })
  }

}